import combineQuery from 'graphql-combine-query';

export default function mergeQueries(operationName, queries) {
  let combiner = combineQuery(operationName);
  for (const query of queries) {
    combiner = combiner.add(query);
  }
  return combiner.document;
}
